/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Expected_CloseInputs */

const cs_field_expected_close = /** @type {(inputs: Field_Expected_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předpokládané uzavření`)
};

const en_field_expected_close = /** @type {(inputs: Field_Expected_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected close`)
};

/**
* | output |
* | --- |
* | "Expected close" |
*
* @param {Field_Expected_CloseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_expected_close = /** @type {((inputs?: Field_Expected_CloseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Expected_CloseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_expected_close(inputs)
	return cs_field_expected_close(inputs)
});